/**
 * Extracted from @atlaskit/docs
 *
 * Used for converting relative imports to package imports
 * e.g. "../../src" -> "@atlaskit/icon"
 */

// @ts-ignore
import replaceImports from 'codesandboxer/dist/replaceImports';

const srcEntryPointRegexString =
	/((?:import|export)[^'"\`]*['"\`])((\.\.\/){1,}src\/)([^/]*['"\`]\s*)/g;

export const transformRelativeImports = (
	sourceCode: string,
	{
		packageName,
	}: {
		packageName: string;
	},
): string => {
	let transformedCode = sourceCode;

	if (packageName) {
		// Replace ../src/<entry-point> with ${packageName}/<entry-point>
		transformedCode = transformedCode.replace(srcEntryPointRegexString, `$1${packageName}/$4`);

		transformedCode = replaceImports(transformedCode, [[`(?:..\/)*src`, packageName]]);
	}

	return transformedCode;
};
